import aaTrackEvent from '../utils/aaTrackEvent';
import { HEADER_LANGUAGE_SWITCH } from './constants';

export const trackLanguageSwitch = ({ languageCode }) => {
  if (document.documentElement.lang === languageCode) {
    return;
  }

  aaTrackEvent(HEADER_LANGUAGE_SWITCH, {
    language_code: languageCode,
  });
};
